export const conditionRenderImg = (profilePhoto: string) =>
  profilePhoto &&
  profilePhoto !==
    'https://res.cloudinary.com/cordasemusica/image/upload/f_webp/v1678224793/avatar_zrtqux.png'
